export enum FilterTypeEnum {
    Is = 1,
    IsNot = 2,
    IsBetween = 3,
    IsNotBetween = 4,
    Contains = 5,
    DoNotContain = 6
  }
  